export default "__VITE_ASSET__qD11YpNz__"